import { receipts } from '../actions';

const initialState = {
  receipts: [],
  fetchReceipt: receipts.types.READY,
  receipt: {}
};

const receipts_reducers = (state = initialState, action) => {
  let newstate;
  switch (action.type) {
    case receipts.types.READY:
      return initialState;
    case receipts.types.FETCHING_RECEIPTS:
      newstate = {
        fetchReceipt: action.type
      };
      return { ...state, ...newstate };
    case receipts.types.FETCHED_RECEIPTS:
      newstate = {
        fetchReceipt: action.type,
        receipts: action.data
      };
      return { ...state, ...newstate };
    case receipts.types.FETCH_RECEIPTS_FAILED:
      newstate = {
        fetchReceipt: action.type
      };
      return { ...state, ...newstate };
    case receipts.types.SET_CURRENT_RECEIPT:
      newstate = {
        receipt: action.receipt
      };
      return { ...state, ...newstate };
    default:
      return state;
  }
};

export default receipts_reducers;



// WEBPACK FOOTER //
// ./src/store/reducers/receipts.js